'use strict';

var processInclude = require('base/util');

processInclude(require('./footer'));
processInclude(require('./header'));
processInclude(require('./banner'));
processInclude(require('./publine'));